import React from "react";

function ZoomOutIcon() {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5H21C21.8284 16.5 22.5 15.8284 22.5 15C22.5 14.1716 21.8284 13.5 21 13.5H9Z"
        fill="#2D3648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0C2.01472 0 0 2.01472 0 4.5V25.5C0 27.9853 2.01472 30 4.5 30H25.5C27.9853 30 30 27.9853 30 25.5V4.5C30 2.01472 27.9853 0 25.5 0H4.5ZM3 4.5C3 3.67157 3.67157 3 4.5 3H25.5C26.3284 3 27 3.67157 27 4.5V25.5C27 26.3284 26.3284 27 25.5 27H4.5C3.67157 27 3 26.3284 3 25.5V4.5Z"
        fill="#2D3648"
      />
    </svg>
  );
}

export default ZoomOutIcon;
